import { registerLocaleData } from '@angular/common';
import { HttpClientModule, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localePT from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterOutlet } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from '@spartacus/storefront';
import { AppComponent } from './app.component';
import { SpartacusModule } from './spartacus/spartacus.module';
import { I18nConfig, I18nModule, provideConfig } from '@spartacus/core';
import { translationChunksConfig, translations } from '../assets/translations/translations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { CustomStoreFrontComponent } from './spartacus/features/store-front/store-front.component';
import { ThemeStoreModule } from './spartacus/features/store-front/misc/theme/core/store/theme-store.module';
import { ProductAuxStoreModule } from './spartacus/features/product/_core/store/product-aux.store.module';
import { UserAuxStoreModule } from './spartacus/features/user/core/store/user-aux.store.module';
import { BaseTmsModule, TmsConfig } from '@spartacus/tracking/tms/core';
import { GtmModule } from '@spartacus/tracking/tms/gtm';
import { primeNGThemeConfig } from './primeng.theme.config';
import { NDBSRecaptchaModule } from './core/recaptcha/recaptcha.module';

registerLocaleData(localePT);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    I18nModule,
    CustomStoreFrontComponent,
    GtmModule,
    BaseTmsModule.forRoot(),
    RouterOutlet,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    ThemeStoreModule,
    ProductAuxStoreModule,
    UserAuxStoreModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    NDBSRecaptchaModule.forRoot(),
    SpartacusModule,
  ],
  providers: [
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
      },
    }),
    provideConfig({
      routing: {
        routes: {
          product: { paths: ['product/:productCode/:slug'] },
        },
      },
    }),
    provideConfig({
      tagManager: {
        gtm: {
          gtmId: environment.googleAnalyticsId,
          events: [],
        },
      },
    } as TmsConfig),
    primeNGThemeConfig.providers,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
